var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,3.4l1.8-1.8v4.3c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V1.7l1.8,1.8c0.1,0.1,0.2,0.1,0.3,0.1 s0.2,0,0.3-0.1c0.2-0.2,0.2-0.5,0-0.7L8.4,0.2C8.3,0.1,8.2,0,8,0C7.8,0,7.7,0.1,7.6,0.2L5.1,2.7c-0.2,0.2-0.2,0.5,0,0.7 C5.3,3.6,5.6,3.6,5.8,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2,12.6l-1.8,1.8v-4.3c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v4.3l-1.8-1.8c-0.2-0.2-0.5-0.2-0.7,0 c-0.2,0.2-0.2,0.5,0,0.7l2.6,2.6c0,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1l2.6-2.6 c0.2-0.2,0.2-0.5,0-0.7C10.7,12.4,10.4,12.4,10.2,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8,7.5H2.2C1.9,7.5,1.7,7.7,1.7,8s0.2,0.5,0.5,0.5h11.6c0.3,0,0.5-0.2,0.5-0.5S14.1,7.5,13.8,7.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReOrder);
export default __webpack_public_path__ + "static/media/re-order.601d203f9a14659c457be20db4ad1d31.svg";
export { ForwardRef as ReactComponent };